import { Container, ContainerProps, IconButton, Stack } from '@mui/material';
import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { Logo } from '../Logo';

const homeButtonStyles = {
  '& img': {
    transform: 'translateY(-1px) scale(1.45)',
  },
};

const Header = ({
  maxWidth = 'xl',
  mainIcon,
}: {
  mainIcon?: ReactNode;
  maxWidth?: ContainerProps['maxWidth'];
}) => {
  return (
    <Container maxWidth={maxWidth}>
      <Stack py={2} direction="row" alignItems="center">
        {mainIcon || (
          <IconButton
            component={Link}
            to="/"
            size="small"
            sx={homeButtonStyles}
          >
            <Logo size={32} />
          </IconButton>
        )}
      </Stack>
    </Container>
  );
};

export { Header };
